"use strict";

import "core-js/modules/es.promise.js";
export const agentCanCopy = async () => {
  try {
    const result = await navigator.permissions.query({
      // @ts-ignore
      name: 'clipboard-write'
    });
    return result.state === 'granted' || result.state === 'prompt';
  } catch (_unused) {
    var _navigator$clipboard;
    // Firefox 63- does not support clipboard permissions
    return typeof ((_navigator$clipboard = navigator.clipboard) === null || _navigator$clipboard === void 0 ? void 0 : _navigator$clipboard.writeText) === 'function';
  }
};